if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.handleKeyup = this.handleKeyup.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
        this.addEventListener("keyup", this.handleKeyup, true);
        this.addEventListener("pointerup", this.handlePointerUp, true);
      }

      handleKeyup(event) {
        if (
          event.code &&
          event.code.toUpperCase() === "ESCAPE" &&
          !event.target.closest('[id^="ModalClose-"]')
        ) {
          event.stopImmediatePropagation();
        }
      }

      handlePointerUp(event) {
        if (!event.target.closest('[id^="ModalClose-"]')) {
          event.stopImmediatePropagation();
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute("data-media-id");
        const modalGallery = this.querySelector("media-gallery");
        if (modalGallery?.setActiveMedia) {
          modalGallery.setActiveMedia(mediaId, false);
          return;
        }

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove("active");
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add("active");
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
      }
    }
  );
}
